import React from 'react';
import {Link} from 'react-router-dom';
import {Polar} from 'react-chartjs-2';

const SAMPLE_DATA = {
  DIET_LABELS: ["Vegetarian", "Vegan", "Gluten-Free", "Paleo", "KETO", "FODMAP"],
  DIET_DATA: [10,8,9,3,5,2],
  ALLERGEN_LABELS: ["Beef", "OtherReadMeat", "WhiteMeat", "Pork", "Fish", "HighSugar", "Cheese", "ShellFish", "Rice", "Eggs", "Mushroom","Peanuts", "Treenuts"],
  ALLERGEN_DATA: [12,12,10,10,10,5,7,10,2,4,,3,15,10]
}

  const COLORS = {
    DIET_BACKGROUND: [
      'rgba(255, 99, 132, 0.65)',
      'rgba(54, 162, 235, 0.65)',
      'rgba(255, 206, 86, 0.65)',
      'rgba(75, 192, 192, 0.65)',
      'rgba(153, 102, 255, 0.65)',
      'rgba(255, 159, 64, 0.65)'
    ],
    DIET_BORDER: [
        'rgba(255,255,255,0.4)',
        'rgba(255, 255, 255, 0.4)',
        'rgba(255, 255, 255, 0.4)',
        'rgba(255, 255, 255, 0.4)',
        'rgba(255, 255, 255, 0.4)',
        'rgba(255, 255, 255, 0.4)'        
    ],
  }


const data = {
      labels: SAMPLE_DATA.DIET_LABELS,
      datasets: [{
          label: '% of Users',
          data: SAMPLE_DATA.DIET_DATA,
          backgroundColor: COLORS.DIET_BACKGROUND,
          borderColor: COLORS.DIET_BORDER,
          borderWidth: 1
      }]
  }
  const options ={
      legend: {
          display: false 
       },
       layout: {
           padding:{
              top: 5
           }
       }
  }




const NoLocationPlaceHolder = () => (
  <div>
    
    <div className="dashboardCardHeading">Add a Location to Get Started.</div>
      
    <Link to='/locations'>
      <button
              className="btn btn-success btn-lg"
              id="nolocationButton"
              onClick={() => { this.setState({ addLocation: true }) }}
            >
              <i className="fa fa-magic"></i>&nbsp; get started
      </button>
    </Link>

    <div className="dashboardCardSubHeading">After you add a location, you can:</div>


      <div className="row" id="planRow">

        <div className="infoCard">
          <div className="infoCardBody">
                <img className="noLocationIcon" src="img/icons/chef.svg" />  
              <div className="noLocationText">
                Verify Your Menu
              </div>  
          </div>
        </div>

        <div className="infoCard">
          <div className="infoCardBody">
              <div id="noLocationChart"> <Polar data={data} options={options} /> </div>
              <div className="noLocationText">
                See Detailed Analytics
              </div>
          </div>
        </div>

        <div className="infoCard">
          <div className="infoCardBody">
                <img className="noLocationIcon" id="noLocationSampleButton" src="img/buttons/button-blue-large.svg" />
                <div className="noLocationText">
                  Publish The Menu On Your Site
                </div>
          </div>
        </div>
    </div>
  </div>
);

export default NoLocationPlaceHolder;


// WEBPACK FOOTER //
// ./src/components/NoLocationPlaceholder/NoLocationPlaceholder.js